module.exports = __webpack_public_path__ + "img/emptyEcharts.dfdeb707.svg";